import {UseQueryResult, useQuery} from 'react-query';

import {Site} from 'src/lib/api/project';
import {ForecastTimesBySource, Source, fetchForecastTimes} from 'src/lib/api/series';

export default function useForecastTimes(
  siteId: Site['id'],
  sources: Source[],
  startDate: Date,
  endDate: Date,
  isStaging: boolean = false
): UseQueryResult<ForecastTimesBySource> {
  return useQuery(['forecastTimes', {siteId, sources, startDate, endDate, isStaging}], () =>
    fetchForecastTimes(siteId, sources, startDate, endDate, isStaging)
  );
}
